import React, { useCallback, useState } from 'react';
import { Menu, IconButton, Box, useTheme, alpha } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

interface ThreeDotMenuProps {
	children: React.ReactNode;
}

const ThreeDotMenu: React.FC<ThreeDotMenuProps> = ({ children }) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const {
		spacing,
		palette: {
			mode,
			grey: { '200': grey200 }
		}
	} = useTheme();

	const handleClick = useCallback(
		(event: React.MouseEvent<HTMLElement>) => {
			event.stopPropagation();
			setAnchorEl(event.currentTarget);
		},
		[setAnchorEl]
	);

	/* istanbul ignore next: cannot click outside */
	const handleClose = useCallback(
		(event: React.MouseEvent<HTMLElement>) => {
			event.stopPropagation();
			setAnchorEl(null);
		},
		[setAnchorEl]
	);

	const handleMenuClick = useCallback(
		(event: React.MouseEvent<HTMLElement>) => {
			event.stopPropagation();
		},
		[]
	);

	return (
		<Box>
			<IconButton
				aria-label="more"
				aria-haspopup="true"
				data-testid="three-dot-menu"
				onClick={handleClick}
			>
				<MoreVertIcon />
			</IconButton>
			<Menu
				onClick={handleMenuClick}
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
				slotProps={{
					paper: {
						sx: {
							boxShadow:
								mode === 'light'
									? `0 0 ${spacing(1.5)} 0 ${alpha(grey200, 1)}`
									: null
						}
					}
				}}
			>
				{children}
			</Menu>
		</Box>
	);
};

export default ThreeDotMenu;
